import React from "react";
import { Button, Container } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";

import SearchBox from "../../../Components/Input/SearchBox";
import ItemList from "../../Components/ItemList";
import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import { getFullName } from "../../../Modules/utils/fullname";
import { getPhoneNumber } from "../../../Modules/utils/phoneno";
import api from "../../../Services/Api/api";
import EditCustomer from "./EditCustomer";
import NavBar from "../../Components/NavBar";

const SCREEN_NAME = "CUSTOMERS_SCREEN";

class CustomersScreen extends AppComponent {
  state = {
    visibleModal: null,
    modalData: null,
    triggerReload: 0,
  };

  additionalQueries = {};

  columns = [
    {
      value: "name",
      label: "Name",
      render: ({ item }) => getFullName(item),
    },
    {
      value: "phone",
      label: "Phone",
      render: ({ item }) => getPhoneNumber(item).formated,
    },
    {
      value: "email",
      label: "Email",
    },
    {
      value: "address",
      label: "Address",
      render: ({ item }) => <div className="multiline">{item.address}</div>,
    },
    {
      value: "introducer",
      label: "Introducer",
      render: ({ item }) => item?.introducer?.description || "",
    },
    {
      value: "actions",
      label: "Actions",
      render: ({ item }) => (
        <>
          <Button
            variant="secondary"
            onClick={() =>
              this.setAsyncState({
                visibleModal: "editCustomer",
                modalData: { customer: item },
              })
            }
          >
            Edit
          </Button>
        </>
      ),
    },
  ];

  async retriveData(query) {
    const { customers } = await api.get("v1/customer", query);
    return customers;
  }

  async setItems(items) {
    this.props.setScreenState({ customers: items });
  }

  onNewCustomer(item) {
    this.setAsyncState({
      visibleModal: null,
      modalData: null,
      triggerReload: Date.now(),
    });
  }

  handleSearchQ(q) {
    if (q) {
      this.additionalQueries = {
        where: {
          $and: [
            {
              $or: [
                {
                  fullName: { $regex: q, $options: "i" },
                },
                {
                  phone: { $regex: q, $options: "i" },
                },
                {
                  email: { $regex: q, $options: "i" },
                },
              ],
            },
          ],
        },
      };
    } else {
      this.additionalQueries = null;
    }
    this.setAsyncState({ triggerReload: Date.now() });
  }

  render() {
    const {
      state: { visibleModal, modalData, triggerReload },
    } = this;

    const screen = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">Customers</div>
          </div>
          <div className="right">
            <SearchBox onChange={this.handleSearchQ.bind(this)} />
            <Button
              onClick={() =>
                this.setAsyncState({
                  visibleModal: "editCustomer",
                  modalData: null,
                })
              }
            >
              Add New Customer
            </Button>
          </div>
        </div>

        <div>
          <ItemList
            {...{
              defaultQuery: {},
              triggerReload,
              items: this.props.customers,
              table: {
                columns: this.columns,
              },
              retriveData: this.retriveData.bind(this),
              setItems: this.setItems.bind(this),
              additionalQueries: this.additionalQueries,
            }}
          />
        </div>

        <EditCustomer
          {...{
            key: `editCustomer-${
              visibleModal === "editCustomer"
                ? modalData?.customer?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "editCustomer",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: (item) => this.onNewCustomer(item),
            ...(modalData || {}),
          }}
        />
      </div>
    );

    return (
      <>
        <NavBar activeLink="/customer" />
        <Container className="gainner">{screen}</Container>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  customers: state.vState[SCREEN_NAME]?.customers || [],
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomersScreen);
